import axios from "axios"
import store from "@/store/"
import { i18n } from "@/locales/setup.js"

/**
 * This interceptor handles network errors and also expired token scenario
 */
export default () => {
	axios.interceptors.response.use(
		config => {
			const res = config.data

			// If authorization or authentication error
			// It's bit hacky here, backend is returning specific strings to signify
			// expired token or authorization error, see below
			if (
				res.errors &&
				res.errors.find(
					item => item.extensions && item.extensions.code === "authorization"
				)
			) {
				// If token expired log out the user and redirect to login
				if (
					res.errors[0] &&
					res.errors[0].message.includes("invalid or expired token")
				) {
					window.TK = null
					window.location = `/${store.state.tenantId}/login?loggedout=true`
				}
			}

			// Eventually return config
			// This step is necessary for axios
			return config
		},
		// If network error, show error message
		err => {
			showError({ code: "general" })

			// Eventually reject promise
			// This step is necessary for axios
			return Promise.reject(err)
		}
	)
}

/**
 * Helper function to display error as a toast message via global store
 */
const showError = ({
	code = "general",
	locale = window.localStorage["covergo-locale"] || "en-US"
}) => {
	store.dispatch("addMessage", {
		message: { type: "error", text: i18n.messages[locale].errors[code] }
	})
}
